import React from 'react';

export const Attachment = ({
  className,
  color = '#46426E',
  width = '24',
  height = '24',
}: {
  className?: string;
  color?: string;
  width?: string;
  height?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2.74284C10.2028 2.2826 9.18353 2.55573 8.72329 3.35288L8.43911 3.8451C8.25501 4.16396 7.84729 4.27321 7.52842 4.08912C7.20956 3.90502 7.10031 3.49729 7.28441 3.17843L7.56859 2.68622C8.39702 1.25134 10.2318 0.759714 11.6667 1.58814C13.1015 2.41657 13.5932 4.25134 12.7647 5.68622L8.43141 13.1918C7.60298 14.6266 5.76821 15.1183 4.33333 14.2898C2.89845 13.4614 2.40683 11.6266 3.23525 10.1918L5.66462 5.98397C6.18264 5.08673 7.32993 4.77931 8.22716 5.29733C9.12439 5.81535 9.43181 6.96264 8.91379 7.85987L6.59876 11.8697C6.41466 12.1885 6.00694 12.2978 5.68808 12.1137C5.36921 11.9296 5.25996 11.5218 5.44406 11.203L7.75909 7.19321C7.90892 6.93369 7.82 6.60186 7.56049 6.45203C7.30098 6.3022 6.96915 6.39112 6.81932 6.65063L4.38995 10.8584C3.92972 11.6556 4.20284 12.6749 5 13.1351C5.79715 13.5954 6.81647 13.3223 7.27671 12.5251L11.61 5.01955C12.0703 4.2224 11.7972 3.20308 11 2.74284Z"
      fill={color}
    />
  </svg>
);
